export enum PaymentServiceType {
    None = 'none',
    Sbp = 'sbp',
    Qiwi = 'qiwi',
    YuMoney = 'yuMoney',
    GooglePay = 'googlePay',
    SberPay = 'sberPay',
    OpenBank = 'openBank'
}
